import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';

//import './index.scss';

import HeaderNavbar from '../../HeaderNavbar';

const LoginLayout = () => {
  const [isLoginPage,setIsLoginPage] = useState(true)
  return (
    <div className="layout-container" style={{height:"100vh", backgroundColor:"#7BD755"}}>
      <HeaderNavbar isLoginPage={isLoginPage} setIsLoginPage={setIsLoginPage} />
      <div>
        <Outlet />
      </div>
    </div>
  );
};

export default LoginLayout;
